import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BaseCompetingTimeSlotsComponent } from '../../abstract-components/base-competing-time-slots.component';
import { CompetingTimeSlotsModule } from '../../competing-time-slots.module';
import { PageEvent } from '@angular/material/paginator';
import { filter, tap } from 'rxjs';
import { EventService } from '~app/app/~shared/services/event.service';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { GlobalEvent } from '~core/models/shared.models';

@Component({
  selector: 'competing-time-slots-list-page',
  standalone: true,
  imports: [CompetingTimeSlotsModule],
  templateUrl: './competing-time-slots-list-page.component.html',
  styleUrl: './competing-time-slots-list-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompetingTimeSlotsListPageComponent extends BaseCompetingTimeSlotsComponent {
  private _resourceFacade = inject(ResourceFacade);
  private _eventService = inject(EventService);

  resources$ = this._resourceFacade.resources$;
  isLoading$ = this._resourceFacade.isLoading$;
  currentError$ = this._resourceFacade.currentError$;
  paginationData$ = this._resourceFacade.paginationData$;

  onGlobalRefresh$ = this._eventService.events$.pipe(
    filter((ev: GlobalEvent) => ev.type === 'REFRESH_DATA'),
    tap(() => this.refreshData())
  );

  refreshData(): void {
    this._resourceFacade.getData({ refresh: true });
  }

  handlePageEvent(e: PageEvent): void {
    this._resourceFacade.setPagination({
      ...(e.pageSize && { itemPerPage: e.pageSize }),
      page: e.pageIndex + 1 || 1
    });
  }
}
